import React from "react";
import { Col, Row } from "react-bootstrap";

import { LineDivider } from "components/layout";
import { TerminalInstallTypes } from "types/enums";

import { InstallationContactView } from "..";
import TextBlock from "../components/textBlock";

import stylesLayout from "../../../../components/layout/layout.module.scss";

type InstallationInformationData = {
	terminal_install: string;
	best_time_to_call: string;
	contact_first_name: string;
	contact_last_name: string;
	contact_phone_number: string;
	contact_email: string;
	notes: string;
};

type InstallationInformationViewProps = {
	data: InstallationInformationData;
};

const InstallationInformationView = ({
	data,
}: InstallationInformationViewProps) => {
	const { terminal_install, best_time_to_call } = data || {};

	const terminalType = terminal_install
		? TerminalInstallTypes.getByValue(Number(terminal_install))?.displayName
		: "None";

	return (
		<>
			<Row>
				<Col>
					<TextBlock
						label=""
						value={terminalType || "Aurora Install"}
						dataAutotest="terminalInstall"
					/>
				</Col>
			</Row>
			<Row>
				<Col xl={12}>
					<TextBlock
						label="Best Time To Call (Pacific Time)"
						value={
							best_time_to_call === "pm"
								? "PM (13:00-17:00)"
								: "AM (07:00 - 11:00)"
						}
						dataAutotest="bestTimeToCall"
					/>
				</Col>
			</Row>
			<LineDivider className={`${stylesLayout.lineDividerHolder}`} />
			<h6
				className={`${stylesLayout.viewSectionTitle} ${stylesLayout.subTitle}`}
			>
				Installation Contact
			</h6>
			<InstallationContactView data={data} />
		</>
	);
};

export default InstallationInformationView;
